import script from "./emailVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./emailVerification.vue?vue&type=script&setup=true&lang=js"

import "./emailVerification.vue?vue&type=style&index=0&id=a6f60258&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6f60258"]])

export default __exports__